import React from "react";
import Link from "react-router-dom/Link";

export default function Popup({ storeNumber, Transaction_Count }) {
  return (
    <div className="popup">
      <div className="popup__content">
        <div className="popup__header">
          <h1>Keep Cashiers Productive</h1>
        </div>
        <div className="popup__body">
          <p>
            Each week, store <span className="red">{storeNumber}</span> had{" "}
            <span className="red">{Transaction_Count}</span> pick ticket item
            transactions. Cashiers should be prepared with the cage combination
            and not require assistance from the head cashier to complete
            transactions. To reduce internal theft opportunities, cage access
            should be limited to:
          </p>

          <ul>
            <li>Cashiers</li>
            <li>MET</li>
            <li>Department Supervisors</li>
            <li>Freight</li>
          </ul>
        </div>

        <div className="popup__footer">
          <Link
            to={{
              pathname: "/solution/2",
              state: { prev: true }
            }}
            className="btn"
          >
            <span className="white-background">Give access</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
